// Model.js
// -----------------------
// @module Case
define("Eureka.MaxaCoupaIntegration.MaxaCoupaIntegration.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/MaxaCoupaIntegration/SuiteScript2/MaxaCoupaIntegration.Service.ss"
            ),
            true
        )
});
});
